export default __webpack_public_path__ + "static/media/IMG_4583-min.702dbe55.JPG";